module.exports = __webpack_public_path__ + "img/headphone.dd2b62aa.svg";